import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=efb6f3a6&"
import script from "./WishList.vue?vue&type=script&lang=js&"
export * from "./WishList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb6f3a6')) {
      api.createRecord('efb6f3a6', component.options)
    } else {
      api.reload('efb6f3a6', component.options)
    }
    module.hot.accept("./WishList.vue?vue&type=template&id=efb6f3a6&", function () {
      api.rerender('efb6f3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/wishList/WishList.vue"
export default component.exports